import { hasIdInArray } from './hasIdInArray';

export const findToggleLayerId = (displayedLayers = [], previousLayers = []) => {
    const isRemoveAction = displayedLayers.length < previousLayers.length;
    const [ biggerArray, shorterArray ] = isRemoveAction ? [ previousLayers, displayedLayers ] : [ displayedLayers, previousLayers ];
    const result = biggerArray.filter(({ id }) => !hasIdInArray(shorterArray, id));
    return result;
};
